import React from 'react';
import { Helmet } from 'react-helmet';

import Faq from '../../Components/Faq/Faq';
import Whychose from '../../Components/Whychoseus/Whychose';

// Importing images (adjust paths if necessary, assuming same structure)
import img1 from '../../Components/Images/001-bulb.png';
import img2 from '../../Components/Images/002-hat.png';
import img3 from '../../Components/Images/003-id-card.png';
import img4 from '../../Components/Images/004-pass.png';

const courses = [
  {
    id: 1,
    iconimg: img1,
    title: "University Listings",
    description: "Explore a wide range of online universities and courses, all in one place. Simplify your application process with Getfast Education.",
  },
  {
    id: 2,
    iconimg: img2,
    title: "Course Insights",
    description: "We connect you with the best online universities, providing transparent insights into faculty, course quality, and fee structures.",
  },
  {
    id: 3,
    iconimg: img3,
    title: "Advanced Comparison Tools",
    description: "Compare universities based on key factors like e-learning systems, EMI options, and accreditation to make an informed decision.",
  },
  {
    id: 4,
    iconimg: img4,
    title: "Unbiased Guidance",
    description: "Enroll in top-rated online programs and take a step toward a successful career with confidence and clarity.",
  },
];

const Aboutus = () => {
  return (
    <div className="bg-white">
      <Helmet>
        <title>About Us - GetFast Education | Best Education Consultancy</title>
        <meta name="description" content="Learn about GetFast Education - India's trusted education consultancy providing guidance for online, regular, and distance college admissions. Expert counseling for all educational services." />
        <meta name="keywords" content="GetFast Education about us, education consultancy India, best consultancy for admissions, online colleges, regular colleges, distance education" />
        <link rel="canonical" href="https://getfasteducation.com/About" />
      </Helmet>
      {/* Banner Section */}
      <div className="bg-brand-orange py-24 px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Empowering Your <span className="text-orange-950">Educational Journey</span>
        </h2>
        <p className="text-white text-lg max-w-2xl mx-auto leading-relaxed opacity-90">
          At Get Fast Education, we are committed to guiding students toward academic success and career excellence. <br className="hidden md:block" />
          With expert educators and personalized support, we help you unlock a world of opportunities.
        </p>
      </div>

      {/* Cards Section */}
      <div className="container mx-auto px-4 py-24">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">How We Help Students</h2>
          <p className="text-gray-500 leading-relaxed">
            Getfast Education simplifies online learning by providing transparent insights into universities, courses, and career opportunities. Find the best online programs tailored to your needs.
          </p>
          <div className="w-24 h-1 bg-brand-orange mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {courses.map((course) => (
            <div key={course.id} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 group hover:-translate-y-2">
              <div className="w-16 h-16 bg-orange-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-brand-orange transition-colors">
                <img src={course.iconimg} alt={course.title} className="w-8 h-8 object-contain filter group-hover:brightness-0 group-hover:invert transition" />
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-3 group-hover:text-brand-orange transition">{course.title}</h4>
              <p className="text-gray-500 text-sm leading-relaxed">{course.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Why Choose Us Section - Assuming Whychose is also updated or acceptable, but ideally should be polished */}
      <div className="bg-gray-50 py-12">
        <Whychose />
      </div>

      {/* FAQ Section */}
      <Faq />

    </div>
  );
}

export default Aboutus;
